export const lightTheme = {
  name: "light",
  grid: {
    container: "81rem",
    smallContainer: "62rem",
  },
  colors: {
    primary: "#167369",

    text: "#252B42",
    second_text: "#737373",
    light_text: "#ffffff",

    page_background: "#f4f5fa",
    dark_background: "#2A2E2D",
    light_background: "#ffffff",

    disabled_element: "#469990",

    muted: "#BDBDBD",

    danger: "#F44336",

    light_gray_2: "#ECECEC",

    green: "#00443D",
  },
  breakpoints: {
    xsmall: "375px",
    small: "576px",
    medium: "768px",
    large: "992px",
    xlarge: "1024",
    xxlarge: "1200px",
    xxxlarge: "1400px",
  },
};
